jQuery(document).ready(function ($) {
    $('div.gallery').masonry({
        itemSelector: '.gallery-item'
    });
});

// Hacking, disable default carusel
window.jetpackCarouselStrings = true;